// Counts the words of an article the way the server does (core/blogs.py word_count): block tags separate words, inline tags do not.
// The server is what enforces the 1000-word minimum; this only has to agree with it so the editor's counter can be trusted.
export default function countWords(html) {
  const text = (html || "")
    .replace(/<\/?(p|div|br|li|h[1-6]|tr|td|th|blockquote|ul|ol|table|section|article)\b[^>]*>/gi, " ")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/g, " ");
  return (text.match(/\S+/g) || []).length;
}
